// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_ef35ebf","cardWrapper":"_c3231ba","card":"_a226f4a"};